import CheckoutFromWrapper from 'features/components/Stripe/CheckoutForm/CheckoutFormWrapper.component'

const Checkout = () => {
  return <CheckoutFromWrapper />
}

export default Checkout
